import {ServiceProviderDTO, ServiceProviderWithBrandsDTO, BrandDTO, CreateProviderRequestDTO, UpdateProviderRequestDTO} from '../models/serviceProvider.dto';
import {ServiceProvider, ServiceProviderWithBrands, Brand} from '../models/serviceProvider.model';

export const mapServiceProviderDTOToModel = (dto: ServiceProviderDTO): ServiceProvider => {
  // تحويل التواريخ من string إلى Date
  const createdAt = dto.created_at ? new Date(dto.created_at) : undefined;
  const updatedAt = dto.updated_at ? new Date(dto.updated_at) : undefined;

  // تحديد نص الحالة بالعربية
  const statusText = dto.status === 'active' ? 'نشط' : 'غير نشط';

  // تحديد الاسم للعرض
  const displayName = dto.full_name || dto.username;

  // Extract company info from provider_info (new structure) or fallback to flat fields (legacy)
  const companyName = dto.provider_info?.company_name || dto.company_name || dto.full_name || 'غير محدد';
  const website = dto.provider_info?.website || dto.website;
  const description = dto.provider_info?.description || dto.description;

  const mapped = {
    id: dto.id.toString(),
    username: dto.username,
    fullName: dto.full_name,
    email: dto.email,
    phoneNumber: dto.phone_number,
    companyName,
    website,
    description,
    status: dto.status,
    createdAt,
    updatedAt,

    // معلومات إضافية للعرض
    displayName,
    statusText,

    // Backward compatibility aliases
    name: dto.full_name,
    phone: dto.phone_number,
    isActive: dto.status === 'active'
  };

  return mapped;
};

export const mapServiceProviderWithBrandsDTOToModel = (dto: ServiceProviderWithBrandsDTO): ServiceProviderWithBrands => {
  const baseProvider = mapServiceProviderDTOToModel(dto);

  const brands = dto.brands?.map(mapBrandDTOToModel) || [];

  return {
    ...baseProvider,
    brands,
    brandsCount: dto.brands_count || brands.length
  };
};

export const mapBrandDTOToModel = (dto: BrandDTO): Brand => {
  const assignedAt = dto.assigned_at ? new Date(dto.assigned_at) : undefined;

  return {
    id: dto.id,
    name: dto.name,
    assignedAt
  };
};

export const mapServiceProviderModelToDTO = (provider: ServiceProvider): ServiceProviderDTO => ({
  id: typeof provider.id === 'string' ? parseInt(provider.id) : provider.id,
  username: provider.username,
  full_name: provider.fullName,
  email: provider.email,
  phone_number: provider.phoneNumber,
  company_name: provider.companyName,
  website: provider.website,
  description: provider.description,
  status: provider.status,
  created_at: provider.createdAt?.toISOString(),
  updated_at: provider.updatedAt?.toISOString()
});
